import { LocalStorageService } from '@df/browser/storage/local-storage.service';
import { Injectable } from '@angular/core';

/**
 * Session storage.
 *
 * @export
 * @class SessionStorage
 * @extends {LocalStorage}
 */
@Injectable({
    providedIn: 'root'
})
export class SessionStorageService extends LocalStorageService {
    /**
     * Storage instance
     * @type {Storage}
     */
    protected override storage: Storage | undefined = typeof window === 'undefined' ? undefined : window.sessionStorage;

    protected override register() {
        this.app.sessionStorageService = this;
    }
}

/**
 * Register service in app.
 */
declare module '@df/core/app' {
    interface App {
        sessionStorageService: SessionStorageService;
    }
}
